import type { FormImageUploadProps } from '../types';
import type { FieldValues } from 'react-hook-form';

import { FormFieldShell } from '../FormFieldShell';

import { ImageUpload } from './ImageUpload';

export const FormImageUpload = <TFieldValues extends FieldValues = FieldValues>(
  props: FormImageUploadProps<TFieldValues>,
) => {
  const {
    name,
    label,
    description,
    hint,
    isRequired,
    url,
    hasSizeLimit = true,
    isRemovable = false,
  } = props;

  return (
    <FormFieldShell
      name={name}
      description={description}
      render={({ field, fieldState, fieldId }) => (
        <ImageUpload
          id={fieldId}
          label={label}
          hint={hint}
          isRequired={isRequired}
          isInvalid={fieldState.invalid}
          url={url}
          hasSizeLimit={hasSizeLimit}
          isRemovable={isRemovable}
          onChange={field.onChange}
        />
      )}
    />
  );
};
